import { GridMainFilter, SortedColumn } from "../../shared/grid/grid.model";

export const GridFiltersKey: string = 'GridFilters';
export const MainFiltersKey: string = 'MainGridFilters';
export const PageNumberKey: string = 'GridPageNumber';
export const PageSizeKey: string = 'GridPageSize';
export const SortedColumnKey: string = 'GridSortedColumn';
export const PreviousProjectTypeKey: string = 'PreviousProjectType';
export const EditedItemIdKey: string = 'EditedItemId';
export const InnerParamsKey: string = 'Inner';

/**
 * Interface for lists, for restoring previous filters and page
 * number on grid, when returning from details view.
 * 
 * 1. Add grid params restoring service injection to constructor:
 * 
 * private gridParamsRestoringService: GridParamsRestoringService
 * 
 * 2. Add call to restore method in onInit()
 * 
 * Ex. implementation:
 * 
 * private tryRestoreFiltersAndPage() {
    var previousGridParams = this.gridParamsRestoringService.getPreviousGridParams(this.detailsPath);
    if(!previousGridParams) {
      return;
    }
    
    this.initialFilters = previousGridParams.initialFilters;
    this.initialSortedColumn = previousGridParams.sortedColumn;
    this.previousMainFilters = previousGridParams.previousMainFilters;
    this.initialPageNumber = previousGridParams.initialPageNumber;
    this.initialPageSize = previousGridParams.initialPageSize;
    this.editedItemId = previousGridParams.editedItemId;
    this.isNewRowAdded = previousGridParams.isNewRowAdded;
    if(previousGridParams.mainFilter) {
      this.mainFilter = previousGridParams.mainFilter;
    }
  }
 * 
 * 3. Add call to save method before navigating to details view
 * 4. Use read values to set up filters and GUI:
 * ex.:
 * if(this.previousMainFilters['ProjectManager']) {
        this.projectManager = this.previousMainFilters['ProjectManager'];
    }
 */
export interface GridParamsRestorable {
    /** add to grid in template:
     * [initialFilters]="initialFilters"
     * */
    initialFilters: any;

    /**  = 0
     * 
     * add to grid in template:
     * [initialPageNumber]="initialPageNumber"
     */
    initialPageNumber: number;

    /**
     * add to grid in template:
     * [initialPageSize]="initialPageSize"
     */
    initialPageSize: number;

    /**
     * add to grid in template:
     * [initialSortedColumn]="initialSortedColumn"
     */
    initialSortedColumn: SortedColumn;

    /**  
     * add to grid in template:
     * [selectedItemId]="editedItemId"
     */
    editedItemId: any;

    /**  = {} */
    previousMainFilters: any;

    /** ex. value = '/projects/project' */
    detailsPath: string;
}

export class GridParamsRestoringResult {
  initialFilters: any;
  initialPageNumber: number = 0;
  initialPageSize: number;
  mainFilter: GridMainFilter[];
  previousMainFilters: any = {};
  sortedColumn: SortedColumn;
  editedItemId: any;
}